<div class="width-100 height-100 demarcacao-areas">
  <div class="container-header">
    <div class="pull-right text-muted">
      <a ng-click="demarcacao.goToNew()" ng-if="$root.permissions.demarcacaoArea.canManage">
        <i class="fa fa-pencil" aria-hidden="true"></i> Nova Demarcação de Área
      </a>
    </div>
    <div class="clearfix"></div>

    <div class="title text-center">
      <h2 ng-show="demarcacao.currentGleba && demarcacao.filters.gleba">
        <strong>{{::(demarcacao.filters.gleba.descricao | characters:20)}}</strong>
      </h2>
      <h2 ng-hide="demarcacao.currentGleba && demarcacao.filters.gleba">
        <strong>HISTÓRICO</strong>
      </h2>
    </div>

    <div ng-show="demarcacao.initialized">
      <!-- Filtros -->
      <div class="btn-group" uib-dropdown dropdown-append-to-body="true" ng-hide="demarcacao.currentGleba && demarcacao.filters.safra">
        <button type="button" class="btn" uib-dropdown-toggle>
           {{demarcacao.filters.safra.descricao || 'Safra' | characters:12}} <span class="caret"></span>
        </button>
        <ul class="dropdown-menu-right" uib-dropdown-menu role="menu">
          <li role="menuitem" ng-show="demarcacao.filters.safra">
            <a ng-click="demarcacao.setFilterAttribute('safra', null, $event)" href="#">Todas</a>
          </li>
          <li class="divider" ng-show="demarcacao.filters.safra"></li>
          <li role="menuitem" ng-repeat="safra in $root.safras | orderBy: '-descricao'">
            <a ng-click="demarcacao.setFilterAttribute('safra', safra, $event)" href="#">{{::safra.descricao}}</a>
          </li>
        </ul>
      </div>

      <div class="btn-group" uib-dropdown dropdown-append-to-body="true">
        <button type="button" class="btn" uib-dropdown-toggle>
          {{(demarcacao.filters.tipo.descricao || 'Tipo')}} <span class="caret"></span>
        </button>
        <ul class="dropdown-menu-right" uib-dropdown-menu role="menu">
          <li role="menuitem" ng-show="demarcacao.filters.tipo">
            <a ng-click="demarcacao.setFilterAttribute('tipo', null, $event)" href="#">Todos</a>
          </li>
          <li class="divider" ng-show="demarcacao.filters.tipos"></li>
          <li role="menuitem" ng-repeat="tipo in demarcacao.tipos | orderBy: 'descricao' track by tipo.id">
            <a ng-click="demarcacao.setFilterAttribute('tipo', tipo, $event)" href="#">{{::tipo.descricao}}</a>
          </li>
        </ul>
      </div>

      <div class="btn-group" uib-dropdown dropdown-append-to-body="true" ng-hide="currentGleba && demarcacao.filters.gleba">
        <button type="button" class="btn" uib-dropdown-toggle>
           {{(demarcacao.filters.gleba.descricao || 'Talhão') | capitalize | characters:10}} <span class="caret"></span>
        </button>
        <ul class="dropdown-menu-right" uib-dropdown-menu role="menu">
          <li role="menuitem" ng-show="demarcacao.filters.gleba">
            <a ng-click="demarcacao.setFilterAttribute('gleba', null, $event)" href="#">Todas</a>
          </li>
          <li class="divider" ng-show="demarcacao.filters.gleba"></li>
          <li role="menuitem" ng-repeat="gleba in demarcacao.glebas | orderBy: 'descricao' track by gleba.id">
            <a ng-click="demarcacao.setFilterAttribute('gleba', gleba, $event)" href="#">{{::gleba.descricao | capitalize}}</a>
          </li>
        </ul>
      </div>

      <div class="btn-group" uib-dropdown dropdown-append-to-body="true">
        <button type="button" class="btn" uib-dropdown-toggle>
           {{(demarcacao.filters.atividade.descricao || 'Cultura') | capitalize | characters:10}} <span class="caret"></span>
        </button>
        <ul class="dropdown-menu-right" uib-dropdown-menu role="menu">
          <li role="menuitem" ng-show="demarcacao.filters.atividade">
            <a ng-click="demarcacao.setAtividade(null, $event)" href="#">Todas</a>
          </li>
          <li class="divider" ng-show="demarcacao.filters.atividade"></li>
          <li role="menuitem" ng-repeat="atividade in demarcacao.atividades | orderBy: 'descricao' track by atividade.id">
            <a ng-click="demarcacao.setAtividade(atividade, $event)" href="#">{{::atividade.descricao | capitalize}}</a>
          </li>
        </ul>
      </div>

      <div class="btn-group" uib-dropdown dropdown-append-to-body="true">
        <button type="button" class="btn" uib-dropdown-toggle  ng-disabled="loadingCultivares">
           {{(demarcacao.filters.cultivar.descricao || 'Cultivar' | characters:10)}} <span class="caret"></span>
        </button>
        <ul class="dropdown-menu-right" uib-dropdown-menu role="menu">
          <li role="menuitem" ng-show="demarcacao.filters.cultivar">
            <a ng-click="demarcacao.setFilterAttribute('cultivar', null, $event)" href="#">Todas</a>
          </li>
          <li class="divider" ng-show="demarcacao.filters.cultivar"></li>
          <li role="menuitem" ng-repeat="cultivar in demarcacao.cultivares | orderBy: 'descricao' track by cultivar.id">
            <a ng-click="demarcacao.setFilterAttribute('cultivar', cultivar, $event)" href="#">{{::cultivar.descricao}}</a>
          </li>
        </ul>
      </div>

      <div class="btn-group" uib-dropdown dropdown-append-to-body="true">
        <button type="button" class="btn" uib-dropdown-toggle>
           {{(demarcacao.filters.operacao.descricao || 'Operação' | characters:10)}} <span class="caret"></span>
        </button>
        <ul class="dropdown-menu-right" uib-dropdown-menu role="menu">
          <li role="menuitem" ng-show="demarcacao.filters.operacao">
            <a ng-click="demarcacao.setFilterAttribute('operacao', null, $event)" href="#">Todas</a>
          </li>
          <li class="divider" ng-show="demarcacao.filters.cultivar"></li>
          <li role="menuitem" ng-repeat="operacao in demarcacao.operacoes | orderBy: 'descricao' track by operacao.id">
            <a ng-click="demarcacao.setFilterAttribute('operacao', operacao, $event)" href="#">{{::operacao.descricao}}</a>
          </li>
        </ul>
      </div>

      <div class="btn-group" uib-dropdown dropdown-append-to-body="true">
        <button type="button" class="btn" uib-dropdown-toggle>
           {{(demarcacao.filters.maquina.descricao || 'Máquina' | characters:10)}} <span class="caret"></span>
        </button>
        <ul class="dropdown-menu-right" uib-dropdown-menu role="menu">
          <li role="menuitem" ng-show="demarcacao.filters.maquina">
            <a ng-click="demarcacao.setFilterAttribute('maquina', null, $event)" href="#">Todas</a>
          </li>
          <li class="divider" ng-show="demarcacao.filters.maquina"></li>
          <li role="menuitem" ng-repeat="maquina in demarcacao.maquinas | orderBy: 'descricao' track by maquina.id">
            <a ng-click="demarcacao.setFilterAttribute('maquina', maquina, $event)" href="#">{{::maquina.descricao}}</a>
          </li>
        </ul>
      </div>

      <div class="btn-group" uib-dropdown dropdown-append-to-body="true" uib-dropdown-toggle>
        <button type="button" class="btn">
          <i
            class="fa pointer"
            ng-class="{'fa-star-o': !demarcacao.filters.favorites, 'fa-star': demarcacao.filters.favorites}">
          </i>
        </button>

        <ul class="dropdown-menu-right" uib-dropdown-menu role="menu">
          <li role="menuitem" ng-show="demarcacao.filters.favorites !== undefined">
            <a ng-click="demarcacao.setFilterAttribute('favorites', undefined, $event)" href="#">Todas</a>
          </li>
          <li class="divider" ng-show="demarcacao.filters.favorites !== undefined"></li>
          <li role="menuitem">
            <a ng-click="demarcacao.setFilterAttribute('favorites', true, $event)" href="#">Somente favoritados</a>
          </li>
          <li role="menuitem">
            <a ng-click="demarcacao.setFilterAttribute('favorites', false, $event)" href="#">Somente não favoritados</a>
          </li>
        </ul>
      </div>

    </div>
    <!-- Fim Filtros -->
    <br><br>
  </div>

  <div class="container-body width-100">
    <p class="text-center" ng-show="!demarcacao.drawPolygons.length">
      <small>Nenhuma Demarcação de Área</small>
    </p>

    <div infinite-scroll="demarcacao.getPolygons()"
        infinite-scroll-container="'historico-demarcacao'"
         infinite-scroll-disabled="!demarcacao.initialized">
      <div class="panel panel-default" ng-repeat="drawPolygon in demarcacao.drawPolygons track by drawPolygon.id" ng-click="demarcacao.openDrawPolygonDetails($event, drawPolygon)">
        <div class="panel-body no-padding">
          <div class="box-area width-20" ng-show="drawPolygon.loading">
            <i class="fa fa-2x fa-spinner fa-spin text-white"></i>&nbsp;
          </div>
          <div class="box-area width-20" ng-hide="drawPolygon.loading" ng-style="{background: drawPolygon.background}">
            <i class="icon-layer" ng-style="{color: drawPolygon.color}"></i>&nbsp;
          </div>
          <div class="box-area-title width-80">
            <h4>
              {{::drawPolygon.descricao}}
              <a class="pull-right" title="Carregar Automaticamente" ng-click="demarcacao.toggleCarregarAutomaticamente($event, drawPolygon)">
                <i
                  class="fa fa-2x pointer"
                  ng-class="{'fa-star-o': !drawPolygon.carregar_automaticamente, 'fa-star text-equilibrio': drawPolygon.carregar_automaticamente}">
                </i>
              </a>
              <small>
                <br>
                <strong> <i class="icon-updated"></i> </strong> em {{::drawPolygon.created_at | date:'dd/MM/yyyy \'às\' HH:mm'}}
              </small>
            </h4>
            <small class="text-muted">
              <div><strong>Tipo: </strong>{{::drawPolygon.tipo.descricao}}</div>

              <div ng-show="drawPolygon.glebas">
                <strong>Talhões: </strong>{{::(drawPolygon.glebas | getTextItems)}}
              </div>

              <div ng-show="drawPolygon.atividade">
                <strong>Cultura: </strong>{{::drawPolygon.atividade.descricao | capitalize}}
              </div>
              <div ng-show="drawPolygon.insumo">
                <strong>Cultivar: </strong>{{::drawPolygon.insumo.descricao}}
              </div>

              <div ng-show="drawPolygon.operador">
                <strong>Operador: </strong>{{::drawPolygon.operador.nome}}
              </div>

              <div ng-show="drawPolygon.empreendimento">
                <strong>Empreendimento: </strong>{{::drawPolygon.empreendimento.descricao}}
              </div>

              <div ng-show="drawPolygon.relacao_campo">
                <strong>Campo de Produção: </strong>{{::drawPolygon.relacao_campo.descricao}}
              </div>

              <div><strong>Usuário: </strong>{{::drawPolygon.usuario.nome | capitalize}}</div>
              <div><strong>Área: </strong>{{::drawPolygon.area | convertM2ToHa | number:2}} ha</div>
              <div ng-show="drawPolygon.tipo.id == 'uso_maquina'"><strong>Largura de Trabalho: </strong>{{::drawPolygon.largura_plantio | number:1}} m</div>
              <div ng-show="drawPolygon.tipo.id == 'uso_maquina' && drawPolygon.allData.distancia"><strong>Distância Percorrida: </strong>{{::drawPolygon.allData.distancia | number:1}} km</div>
              <div ng-show="drawPolygon.tipo.id == 'uso_maquina' && drawPolygon.allData.velocidadeMedia"><strong>Velocidade Média: </strong>{{::drawPolygon.allData.velocidadeMedia | number:1}} km/h</div>
              <a ng-show="drawPolygon.tipo.id == 'uso_maquina'" prevent-event href="#" ng-click="demarcacao.openUsosMaquina(drawPolygon.maquina_id, drawPolygon.created_at)">
                Visualizar usos da máquina no dia
              </a>
              <a ng-click="demarcacao.clickLink($event)" ng-href="{{drawPolygon.linkKml}}" class="m-t-sm width-100" style="display: inline-block;">
                <i class="fa fa-download" aria-hidden="true"></i> Exportar para Arquivo KML
              </a>

              <br>
              <div>
                <span class="pull-right">
                  <a ng-click="demarcacao.edit(drawPolygon, $event)"><u><i class="fa fa-cog" aria-hidden="true" ></i>Editar</u></a>
                </span>
              </div>
            </small>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
